export default "__VITE_ASSET__qRLCyWob__"